// extracted by mini-css-extract-plugin
export var actions = "_v1-4";
export var item = "_v1-1";
export var price = "_v1-3";
export var quantity = "_v1-2";
export var table = "_v1-0";